(function () {
    $(".banner-image-container").on("click", (e) => {
        const idModal = $(e.currentTarget).attr("data");

        $(`#${idModal}`).removeClass("fade").addClass("d-flex");
    });

    $(".btn-close").on("click", (e) => {
        $(e.currentTarget).closest(".bannermodal-modal").addClass("fade").removeClass("d-flex");
    });
})();
